import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view on every React Router navigation (SPA fix).
// Skips the owner-only /admin area so it never pollutes visitor analytics.
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    if (location.pathname.startsWith("/admin")) return;
    // Defer a tick so the route's <title> (set via usePageMeta) is current.
    const id = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href,
      });
    }, 0);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
